import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { VideoRecordingInstance } from '../video-recording';

@Injectable({
  providedIn: 'root'
})
export class VideoRecordingManagerService {
  private activeRecordings = new Map<string, VideoRecordingInstance>();
  private recordingsStopping$ = new BehaviorSubject<boolean>(false);

  public registerRecording(instance: VideoRecordingInstance): void {
    this.activeRecordings.set(instance.id, instance);
  }

  public unregisterRecording(id: string): void {
    this.activeRecordings.delete(id);
  }

  public async stopAllRecordings(): Promise<void> {
    const activeInstances = Array.from(this.activeRecordings.values());

    if (activeInstances.length === 0) {
      return;
    }

    this.recordingsStopping$.next(true);

    const stoppingPromises = activeInstances.map(instance => {
      return new Promise<void>(resolve => {
        if (instance.isRecording()) {
          instance.stopRecording();
          setTimeout(() => resolve(), 1000);
        } else {
          resolve();
        }
      });
    });

    await Promise.all(stoppingPromises);

    this.recordingsStopping$.next(false);
  }

  public hasActiveRecordings(): boolean {
    return Array.from(this.activeRecordings.values()).some(instance => instance.isRecording());
  }

  public isStoppingRecordings(): boolean {
    return this.recordingsStopping$.value;
  }
}
